export function formataNumeroProcesso (n) {
    const tmp = String(n).replace(/\D/g, '')
    if (!tmp) return n || '-'
    return tmp.replace(/(\d{7})(\d{2})(\d{4})(\d)(\d{2})(\d*)/, '$1-$2.$3.$4.$5.$6')
    // return `${n.substr(0, 7)}-${n.substr(7, 2)}.${n.substr(9, 4)}.${n.substr(13, 1)}.${n.substr(14, 2)}.${n.substr(16, 4)}`
}
